<template>
	<div
		class="w-6 h-6 rounded-md mr-3 flex items-center justify-center ring-1 ring-border-primary hover:ring-border-select"
		:class="[hover && 'ring-border-select', pressed && 'bg-background-tertiary']"
	>
		<NuxtIcon
			v-show="checked"
			name="check"
			class="text-xl text-icon-primary"
			filled
		/>
	</div>
</template>

<script setup lang="ts">
	type Props = {
		checked: boolean;
		hover?: boolean;
		pressed?: boolean;
	};

	defineProps<Props>();
</script>
